// +----------------------------------------------------------------------
// | CNXRC [ CNXRC赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2026 https://www.cnxrc.net All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CNXRC并不是自由软件，未经许可不能去掉CNXRC相关版权
// +----------------------------------------------------------------------
// | Author: CNXRC Team <admin@cnxrc.net>
// +----------------------------------------------------------------------

var components = require.context('./', false, /\.vue$/);
export default (function (Vue) {
  components.keys().map(function (item) {
    Vue.component(components(item).default.name, components(item).default);
  });
});